<template>
  <div class="archive-wrapper">

      <div class="events_slider_yellow">
        <div class="events_slider_title">Najnoviji eventi</div>
        <div class="events_slider_description">Lista najnovijih evenata u orgnizaciji ShowConcept</div>
      </div>

      <div class="archive_big_title">Arhiva</div>
      <div class="archive_small_title">Eventi</div>
  
      <!-- query posts -->
      <div class="archive_list_wrapper">
        <div class="arhive_list">
          <div v-for="(post, key) in posts" :key="key">
            <router-link :to="{ path:'/eventi/' +post.uid }"> 
              <div class="events_slider_inner">
                <prismic-image :field="post.data.thumbnail" class="home_thumbnail"/>
                <div class="events_slider_text">
                  <div class="events_slider_text_title">
                    <h3>{{ $prismic.richTextAsPlain(post.data.event_title) | truncate(43, '...') }}</h3>
                  </div>
                  <div class="events_slider_text_description">
                    {{ $prismic.richTextAsPlain(post.data.event_description) | truncate(142, '...') }}
                  </div>
                </div><!-- events slider text -->
              </div><!-- events slider inner -->
            </router-link>
          </div><!-- end query posts -->
        </div> <!-- end archive list  -->
      </div><!-- end archive list wrapper -->
  
    <div class="event_company_name">
      ShowConcept
    </div>

  </div><!-- end home wrapper -->
</template>

<script>
import $ from 'jquery'

export default {
  name: 'HomePage',
  data () {
    return {
      //slider
      posts: []
    }
  },
  methods: {

    getContent () {
        this.$prismic.client.query(
          this.$prismic.Predicates.at('document.type', 'events'),
          { pageSize : 20  }
          ).then((response) => {
            const posts = response.results;
            this.posts = posts;

            //loader
            $('.loader_wrapper').fadeOut('slow').promise().done(function(){ 
              $('.archive-wrapper').fadeIn('slow');
            });            
        });
    }

    
  },
  mounted () {
    this.getContent();
    $(document).scrollTop(0);
    $('.archive-wrapper').hide(); 
  },
  beforeCreate: function() {
      document.body.className = 'archive';
      $('.loader_wrapper').css('display','flex');
  }  
}
</script>